export default __webpack_public_path__ + "static/media/Planet-Scroll.5bd84748.png";